<div class="modal-header">
    <h5 class="modal-title">Hatırlatma Ayarları</h5>
    <button type="button" class="close" aria-label="Close" (click)="onClose(false)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <div formArrayName="settings">
            <div *ngFor="let row of settings.controls; let i = index" [formGroupName]="i"
                class="row align-items-end mb-2">

                <div class="col-md-5">
                    <label>Kaç Gün Önceden Çalışsın</label>
                    <input type="number" class="form-control" formControlName="daysBefore">
                </div>

                <div class="col-md-5">
                    <label>Günde Kaç Defa</label>
                    <input type="number" class="form-control" formControlName="timesPerDay"
                        [readonly]="!authService.isEndpointStatus('PUT.Updateing.UpdateReminderSetting')">
                </div>

                <div class="col-md-2">
                    <button type="button" class="btn btn-danger mt-4" appDelete controller="ReminderSettings"
                        [id]="row.get('id')?.value" (callback)="removeCallBack()"
                        *ngIf="authService.isEndpointStatus('DELETE.Deleteing.RemoveReminderSetting')">Sil</button>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-success mt-2" (click)="addRow()"
            *ngIf="authService.isEndpointStatus('POST.Writing.CreateReminderSetting')">+ Yeni Ayar</button>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onClose(false)">İptal</button>
    <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()"
        *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateReminderSetting') || authService.isEndpointStatus('POST.Writing.CreateReminderSetting')">Kaydet</button>
</div>  